const metrics = [
  {
    value: '3.2×',
    label: 'More booked jobs',
    context: 'vs. manual processes',
    icon: 'ri-calendar-check-line',
  },
  {
    value: '94%',
    label: 'Fewer missed calls',
    context: 'AI answers every inquiry',
    icon: 'ri-phone-line',
  },
  {
    value: '<2m',
    label: 'Average response time',
    context: 'Down from hours',
    icon: 'ri-flashlight-line',
  },
  {
    value: '67%',
    label: 'Higher close rates',
    context: 'Automated follow-ups work',
    icon: 'ri-funds-line',
  },
];

export default function ResultsSection() {
  return (
    <section className="bg-[#0A0A0A] py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-20">
          <p className="text-white/35 text-sm font-semibold uppercase tracking-widest mb-5">
            Proven Results
          </p>
          <h2 className="text-5xl lg:text-6xl font-extrabold text-white leading-none tracking-tighter">
            Numbers that speak for
            <br />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage: 'linear-gradient(90deg, #F59E0B, #FBBF24)',
              }}
            >
              themselves.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/6 rounded-2xl overflow-hidden">
          {metrics.map((metric, idx) => (
            <div
              key={metric.label}
              className={`bg-[#0A0A0A] p-10 text-center hover:bg-white/3 transition-colors ${
                idx < 3 ? 'border-r border-white/6' : ''
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-white/6 rounded-xl mx-auto mb-6">
                <i className={`${metric.icon} text-white/50 text-lg`} />
              </div>
              <div className="text-5xl lg:text-6xl font-extrabold text-white tracking-tighter mb-3">
                {metric.value}
              </div>
              <h3 className="text-white/80 text-base font-semibold mb-2 tracking-tight">
                {metric.label}
              </h3>
              <p className="text-white/30 text-sm">{metric.context}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
